
































import { Component, Prop, Vue } from "vue-property-decorator";
import { Global } from "../../core/helpers/global";

@Component({
  inheritAttrs: false,
})
export default class CtaButton extends Vue {
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: String, default: "" }) to!: string;
  @Prop({ type: String, default: "" }) href!: string;
  @Prop({ type: String, default: "lg" }) size!: string;
  @Prop({ type: String, default: "solid" }) variant!: string;
  @Prop({ type: Boolean, default: false }) fullWidth!: boolean;
  @Prop({ type: Number, default: 0 }) width!: number;
  @Prop({ type: Boolean, default: true }) showIcon!: boolean;

  get componentTag() {
    if (this.to) return "router-link";
    if (this.href) return "a";
    return "button";
  }

  get componentAttrs() {
    const attrs: any = { ...(this.$attrs || {}) };
    if (this.componentTag === "router-link") {
      return { ...attrs, to: this.to };
    }
    if (this.componentTag === "a") {
      return { ...attrs, href: this.href };
    }
    if (attrs.type === undefined) attrs.type = "button";
    return attrs;
  }

  get sizeClass() {
    return this.size === "sm" ? "ctaButton--sm" : "ctaButton--lg";
  }

  get variantClass() {
    if (!this.variant || this.variant === "solid") return "";
    return `ctaButton--${this.variant}`;
  }

  get widthStyle() {
    if (!this.width) return {};
    return { width: `${this.width}px` };
  }

  handleClick(e: Event) {
    const id = (this.$attrs && this.$attrs.id) || "";
    if (typeof id === "string" && id) {
      Global.TriggerDomId = id;
    }
    return e;
  }
}
